import {createSvgIcon} from '../create-svg-icon';

export const SignalWifiStatusbar4BarIcon = createSvgIcon(
  <path d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98C20.93 5.9 16.69 4 12 4z" />
, 'SignalWifiStatusbar4BarOutlined');
